import { render, staticRenderFns } from "./Premio_body.vue?vue&type=template&id=54284dce"
import script from "./Premio_body.vue?vue&type=script&lang=js"
export * from "./Premio_body.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports